<template>
  <content-page back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Referrer End User License Agreement
      </div>
    </template>

    <PrivacyPolicy />
  </content-page>
</template>

<script>
import { ContentPage } from '@/components/pages'
import PrivacyPolicy from '@/components/documents/Privacy_2023_07_15'

export default {
  name: 'LoginPrivacyPolicy',

  components: { ContentPage, PrivacyPolicy },
}
</script>
